const inputDurationElements = document.querySelectorAll('#nachsendeauftrag input[name="duration"]');
const priceElement = document.querySelector('#nachsendeauftrag .m-form-service__price strong');
function updatePrice() {
  const checkedPricesElement = Array.from(inputDurationElements).find((pricesElement) => pricesElement.checked);
  if (checkedPricesElement) {
    priceElement.innerText = checkedPricesElement.dataset.price;
  }
}
inputDurationElements.forEach((pricesElement) => pricesElement.addEventListener('change', updatePrice));
updatePrice();
